/**
 * ID池管理器
 * 用于管理实体ID的分配和回收
 */
export class IdentifierPool {
    constructor() {
        this._nextAvailableId = 0;
        this._ids = [];
    }
    /**
     * 获取一个可用的ID
     */
    checkOut() {
        if (this._ids.length > 0) {
            return this._ids.pop();
        }
        return this._nextAvailableId++;
    }
    /**
     * 回收一个ID
     * @param id 要回收的ID
     */
    checkIn(id) {
        this._ids.push(id);
    }
}
//# sourceMappingURL=IdentifierPool.js.map